/**
 * Odczyt stanu zaawansowanych filtrów i widoczności kolumn z Redux.
 * Wybiera slice w zależności od isDynamicUI (traderPanel vs dynamicPage).
 */
import { useSelector } from 'store';
import type { IWiseTableAdvancedFilter } from 'components/wise/types';

export interface UseReduxStateParams {
  componentSymbol: string;
  pageSymbol?: string;
}

export function useReduxState({ componentSymbol, pageSymbol }: UseReduxStateParams) {
  const isDynamicUI = !!pageSymbol;

  const savedFiltersFromRedux = useSelector((state) =>
    isDynamicUI && pageSymbol
      ? state.dynamicPage?.wiseTableAdvancedFilters?.[pageSymbol]?.[componentSymbol]
      : state.traderPanel?.wiseTableAdvancedFilters?.[componentSymbol]
  ) as IWiseTableAdvancedFilter[] | undefined;

  const columnVisibilityFromRedux = useSelector((state) =>
    isDynamicUI && pageSymbol
      ? state.dynamicPage?.wiseTableColumnVisibility?.[pageSymbol]?.[componentSymbol]
      : state.traderPanel?.wiseTableColumnVisibility?.[componentSymbol]
  ) as Record<string, boolean> | undefined;

  const columnOrderFromRedux = useSelector((state) =>
    isDynamicUI && pageSymbol
      ? state.dynamicPage?.wiseTableColumnOrder?.[pageSymbol]?.[componentSymbol]
      : state.traderPanel?.wiseTableColumnOrder?.[componentSymbol]
  ) as string[] | undefined;

  const selectedSettingsPresetIdFromRedux = useSelector((state) =>
    isDynamicUI && pageSymbol
      ? state.dynamicPage?.wiseTableSelectedSettingsPresetId?.[pageSymbol]?.[componentSymbol]
      : state.traderPanel?.wiseTableSelectedSettingsPresetId?.[componentSymbol]
  ) as string | null | undefined;

  const savedFilters = savedFiltersFromRedux || [];
  const columnVisibility = columnVisibilityFromRedux ?? {};
  const columnOrder = columnOrderFromRedux ?? [];
  const selectedSettingsPresetName = selectedSettingsPresetIdFromRedux ?? null;

  return {
    savedFilters,
    columnVisibility,
    columnOrder,
    selectedSettingsPresetName,
    selectedSettingsPresetIdFromRedux: selectedSettingsPresetIdFromRedux ?? null,
    isDynamicUI,
    pageSymbol,
    componentSymbol
  };
}
